import { IActionResult, IActionResponse, ActionResult, ActionResponse, } from "../lib";
import { CustomProcessResponse, CustomProcessResponseAsync, GetApplicationSetting, IApplicationSettings, } from "../../configuration";
import { showSnackbar } from "../../vfx/snackbar/snackbar";
import { MessageSeverity } from "../lib/messageSeverity";
import { StringHelper } from "./stringHelper";

export namespace ServiceHelper {

    export function GetImageUrl(imagePath: string | undefined | null): string {
        if (!imagePath) {
            return '';
        }

        const applicationSetting: IApplicationSettings = GetApplicationSetting;
        const value: string = StringHelper.enforceEndsWith(applicationSetting.serviceSettings.hostUrl, '/') + imagePath;
        return value;
    }
  export function CreateSuccessfulResult<T>(data: T): IActionResult<T> {
    var result: IActionResult<T> = new ActionResult<T>();
    result.operationStatusCode = 200;
    result.isSuccess = true;
    result.result = data;
    return result;
  }

  export function CreateErrorResult<T, U = IActionResult<T>>(
    data: T | undefined,
    errors: string[]
  ): U {
    var result: IActionResponse = new ActionResult<T>();
    result.operationStatusCode = 400;
    result.isSuccess = false;
    if (errors === undefined || errors === null || errors.length === 0) {
      for (let i = 0; i < errors.length; i++) {
        result.errorMessages?.push(errors[i]);
      }
    }
    return result as U;
  }

  export function CreateErrorResponse(errors: string[]): IActionResponse {
    var result: IActionResponse = new ActionResponse();
    result.operationStatusCode = 400;
    if (errors === undefined || errors === null || errors.length === 0) {
      for (let i = 0; i < errors.length; i++) {
        result.errorMessages?.push(errors[i]);
      }
    }
    return result;
  }

  //Action Response
  export async function handleActionResponseAsync(
    response: Promise<IActionResponse>
  ): Promise<IActionResponse> {
    return ProcessResponseAsync(response);
  }

  export function handleActionResponse(
    response: IActionResponse
  ): IActionResponse {
    return ProcessResponse(response);
  }

  //Action Results
  export async function handleGetActionResultAsync<T, U = IActionResult<T>>(
    response: Promise<U>
  ): Promise<U> {
    ProcessResponseAsync(response as Promise<IActionResponse>);
    return response;
  }

  export function handleGetActionResult<T, U = IActionResult<T>>(result: U): U {
    ProcessResponse(result as IActionResponse);
    return result;
  }

  export async function handleActionResultAsync<T, U = T, V = IActionResult<U>>(
    response: Promise<V>
  ): Promise<V> {
    ProcessResponseAsync(response as Promise<IActionResponse>);
    return response;
  }

  export function handleActionResult<T, U = T, V = IActionResult<U>>(
    result: V
  ): V {
    ProcessResponse(result as IActionResponse);
    return result;
  }

  ////Paged Results
  //export async function handlePagedResultAsync<TDto>(response: Promise<IPagedResult<TDto>>): Promise<IPagedResult<TDto>> {
  //    const result: IPagedResult<TDto> = await response;
  //    return handlePagedResult(result);
  //}

  //export function handlePagedResult<TDto>(result: IPagedResult<TDto>): IPagedResult<TDto> {
  //    ProcessResponse(result);
  //    return result;
  //}

  //Process Response
  function ProcessResponse(response: IActionResponse) {
    //List of all processes
    CustomProcessResponse(response);
    HandleSnackbar(response);
    return response;
  }

  async function ProcessResponseAsync(response: Promise<IActionResponse>) {
    //List of all processes
    await CustomProcessResponseAsync(response);
    await HandleSnackbarAsync(response);
    return response;
  }

    function HandleSnackbar(response: IActionResponse) {
        if (response.isCancelled) {
            return;
        }
        if (!response.isSuccess && response.errorMessages?.length) {
            showSnackbar(response.errorMessages.join(", "), MessageSeverity.Error);
        }
    }

  async function HandleSnackbarAsync(
    responsePromise: Promise<IActionResponse>
  ) {
    const response = await responsePromise;
    HandleSnackbar(response);
  }
}
